import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {LeadTypeState} from "./LeadTypeState";
import {
	LEAD_TYPE_CREATED,
	LEAD_TYPE_FETCHED,
	LEAD_TYPE_SORT_ORDER_UPDATED,
	LEAD_TYPE_UPDATED
} from "../../action/leadType/actionType";

const initState: LeadTypeState = {
	leadTypes: none
};

const reducer = handleActions({
	[LEAD_TYPE_FETCHED]: (state: LeadTypeState,
		action: Action<any>): LeadTypeState => {
		return {...state, leadTypes: option(action.payload.leadTypes)}
	},
	[LEAD_TYPE_CREATED]: (state: LeadTypeState,
		action: Action<LEAD_TYPE_CREATED>): LeadTypeState => {
		return {
			...state,
			leadTypes: option(state.leadTypes.getOrElse([]).concat(action.payload.leadType))
		}
	},
	[LEAD_TYPE_UPDATED]: (state: LeadTypeState,
		action: Action<LEAD_TYPE_UPDATED>): LeadTypeState => {
		const leadTypes = state.leadTypes.getOrElse([]).map(
			t => t.id == action.payload.leadType.id ? action.payload.leadType : t);
		return {...state, leadTypes: option(leadTypes)}
	},
	[LEAD_TYPE_SORT_ORDER_UPDATED]: (state: LeadTypeState,
		action: Action<LEAD_TYPE_SORT_ORDER_UPDATED>): LeadTypeState => {
		return {...state, leadTypes: option(action.payload.leadTypes)};
	},
}, initState);

export default reducer;
